// @ts-nocheck
import type { UnitDimension } from './types';

export function roundQuantity(
  value: number,
  dimension: UnitDimension,
  decimals: number,
): number {
  if (!Number.isFinite(value)) {
    return value;
  }

  let effectiveDecimals = decimals;
  const abs = Math.abs(value);

  if (abs > 0 && abs < 0.01) {
    effectiveDecimals = Math.max(decimals, 4);
  } else if (abs >= 1000) {
    effectiveDecimals = Math.max(0, decimals - 1);
  } else if (abs >= 10000) {
    effectiveDecimals = 0;
  }

  const factor = 10 ** effectiveDecimals;
  return Math.round(value * factor) / factor;
}
